const headRowsSupport = {
  file: 'Arquivo',
  updatedAt: 'Modificado em',
  size: 'Tamanho',
  download: 'Download',
  type: 'Visibilidade',
  description: 'Descrição',
  admin: 'Editar'
};

export default headRowsSupport;
